import { render } from "./TabAdditionalMarkets.vue?vue&type=template&id=d7632cf0&scoped=true"
import script from "./TabAdditionalMarkets.vue?vue&type=script&lang=js"
export * from "./TabAdditionalMarkets.vue?vue&type=script&lang=js"

import "@/assets/scss/retail/tab-main-markets.scss?vue&type=style&index=0&id=d7632cf0&scoped=true&lang=scss"
import "@/assets/scss/retail/additional-market.scss?vue&type=style&index=1&id=d7632cf0&scoped=true&lang=scss"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7632cf0"]])

export default __exports__